import React from 'react';
import { green, grey } from 'globals/colors';

interface FsCheckMarkInCircleIconProps {
  color?: string;
}

const FsCheckMarkInCircleIcon: React.FC<FsCheckMarkInCircleIconProps> = ({
  color = green.MAIN,
}) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.344541"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z"
        fill={grey.V4}
      />
      <path
        d="M13.3897 6.93923L7.7328 12.5961L4.19727 9.06055"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default FsCheckMarkInCircleIcon;
